module.exports = __webpack_public_path__ + "static/img/aim.996bf0a8.svg";